import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=4940fa92&"
import script from "./Home.vue?vue&type=script&lang=ts&"
export * from "./Home.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4940fa92')) {
      api.createRecord('4940fa92', component.options)
    } else {
      api.reload('4940fa92', component.options)
    }
    module.hot.accept("./Home.vue?vue&type=template&id=4940fa92&", function () {
      api.rerender('4940fa92', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/home/v2/Home.vue"
export default component.exports